<template>
  <div class="contact_index">
    <div class="contact_index_text">
      <p style="font-size: 24px;margin-bottom: 2vh" class="animate__fadeInUp animate__animated">About Us</p>
      <p style="font-size: 36px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-1s">Headquartered in the US, SIG is a global proprietary trading</p>
      <p style="font-size: 36px;margin-bottom: 0" class="animate__fadeInUp animate__animated animate__delay-1s">and broker-dealer firm founded with an entrepreneurial</p>
      <p style="font-size: 36px;margin-bottom: 2vh" class="animate__fadeInUp animate__animated animate__delay-1s">mindset and a rigorous analytical approach to decision making.</p>
      <p style="margin-bottom: 0;font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">SIG's business thrives at the intersection of
        trading, quantitative research, and technology.</p>
      <p style="margin-bottom: 0;font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">SIG now has over 2,500 employees worldwide.</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Contact_index_en',
  components: {DownOutlined,},
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }

}
</script>
<style scoped>
.contact_index {
  background-image: url("../../../assets/background/contact_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
  text-align: left;
}

.contact_index_text {
  padding-top: 30vh;
  margin-left: 12vw;
}

.index_down {
  padding-top: 2vh;
  padding-left: 6vw;
}
</style>